import { render, staticRenderFns } from "./CartItemList.vue?vue&type=template&id=51a5e1d4&"
import script from "./CartItemList.vue?vue&type=script&lang=js&"
export * from "./CartItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports